export default class HealthStatus {
  static PENDING = 'PENDING';
  static UNKNOWN = 'UNKNOWN';
  static UNHEALTHY = 'UNHEALTHY';
  static HEALTHY = 'HEALTHY';
}
